// ES content translations. Keyed `<type>.<id>.<field>`. From content-i18n workflow.
export const contentEs: Record<string, string> = {
  "card.trade-routes.name": "Rutas Comerciales",
  "card.trade-routes.desc": "+25% a toda la producción de recursos.",
  "card.sharpened-tools.name": "Herramientas Afiladas",
  "card.sharpened-tools.desc": "+35% de daño de recolección.",
  "card.wide-survey.name": "Prospección Amplia",
  "card.wide-survey.desc": "+20% de radio del círculo de recolección.",
  "card.guild-labor.name": "Mano de Obra Gremial",
  "card.guild-labor.desc": "+45% de tasa de recolección automática.",
  "card.efficient-masons.name": "Albañiles Eficientes",
  "card.efficient-masons.desc": "Los edificios cuestan 15% menos.",
  "card.standing-army.name": "Ejército Permanente",
  "card.standing-army.desc": "+40% de defensa y +10 de defensa fija.",
  "card.stone-walls.name": "Murallas de Piedra",
  "card.stone-walls.desc": "+22 de defensa fija.",
  "card.drilled-ranks.name": "Tropas Adiestradas",
  "card.drilled-ranks.desc": "+20% de defensa y +8 de defensa fija.",
  "card.war-economy.name": "Economía de Guerra",
  "card.war-economy.desc": "+50% de defensa.",
  "card.watchtowers.name": "Atalayas",
  "card.watchtowers.desc": "+15% de defensa y +12% de producción.",
  "card.scholars.name": "Eruditos",
  "card.scholars.desc": "+45% de producción de conocimiento y tecnología.",
  "card.scientific-method.name": "Método Científico",
  "card.scientific-method.desc": "+25% de conocimiento y +15% de producción.",
  "card.enlightenment.name": "Ilustración",
  "card.enlightenment.desc": "+30% de conocimiento y +12% de defensa.",
  "card.mass-schooling.name": "Educación Masiva",
  "card.mass-schooling.desc": "+25% de conocimiento y +20% de recolección automática.",
  "card.engineering.name": "Ingeniería",
  "card.engineering.desc": "+20% de producción y los edificios cuestan 10% menos.",
  "synergy.industrial-revolution.name": "Revolución Industrial",
  "synergy.industrial-revolution.desc": "Dos vías económicas se combinan: +50% de producción.",
  "synergy.fortress.name": "Fortaleza",
  "synergy.fortress.desc": "Dos vías militares se combinan: +45% de defensa y +25 fija.",
  "synergy.great-library.name": "Gran Biblioteca",
  "synergy.great-library.desc": "Dos vías de conocimiento se combinan: +60% de conocimiento y +25% de producción.",
  "synergy.renaissance.name": "Renacimiento",
  "synergy.renaissance.desc": "La economía se une al conocimiento: +30% de producción y +30% de conocimiento.",
  "synergy.war-machine.name": "Máquina de Guerra",
  "synergy.war-machine.desc": "La economía se une a lo militar: +20% de defensa y +25% de producción.",
  "synergy.enlightened-guard.name": "Guardia Ilustrada",
  "synergy.enlightened-guard.desc": "El conocimiento se une a lo militar: +20% de defensa y +30% de conocimiento.",
  "synergy.golden-age.name": "Edad de Oro",
  "synergy.golden-age.desc": "Las tres vías en equilibrio: +35% de producción y conocimiento, +20% de defensa.",
  "skill.bountiful-start.name": "Comienzo Abundante",
  "skill.bountiful-start.desc": "Empieza cada partida con más madera, piedra y mineral.",
  "skill.settlers.name": "Colonos",
  "skill.settlers.desc": "Empieza cada partida con población extra.",
  "skill.industrious.name": "Laborioso",
  "skill.industrious.desc": "+8% de producción global por nivel.",
  "skill.sharp-tools.name": "Herramientas Afiladas",
  "skill.sharp-tools.desc": "+10% de daño de recolección por nivel.",
  "skill.wide-reach.name": "Largo Alcance",
  "skill.wide-reach.desc": "+10% de radio del círculo de recolección por nivel.",
  "skill.fortified.name": "Fortificado",
  "skill.fortified.desc": "+12% de defensa del asentamiento por nivel.",
  "skill.swift-hands.name": "Manos Rápidas",
  "skill.swift-hands.desc": "+10% de recolección automática por nivel.",
  "skill.long-memory.name": "Memoria Larga",
  "skill.long-memory.desc": "+1 hora de límite sin conexión por nivel.",
  "skill.war-chest.name": "Botín de Guerra",
  "skill.war-chest.desc": "Empieza cada partida con botín para gastar en tecnología.",
  "skill.archivist.name": "Archivero",
  "skill.archivist.desc": "+10% de conocimiento y defensa tecnológica por nivel.",
  "skill.master-mason.name": "Maestro Albañil",
  "skill.master-mason.desc": "Los edificios cuestan 5% menos por nivel.",
  "tech.irrigation.name": "Irrigación",
  "tech.irrigation.desc": "+30% de producción.",
  "tech.masonry.name": "Albañilería",
  "tech.masonry.desc": "Los edificios cuestan 20% menos.",
  "tech.cartography.name": "Cartografía",
  "tech.cartography.desc": "+30% de radio de recolección y +25% de daño de recolección.",
  "tech.logistics.name": "Logística",
  "tech.logistics.desc": "+75% de recolección automática.",
  "tech.conscription.name": "Reclutamiento",
  "tech.conscription.desc": "+45% de defensa.",
  "tech.bulwark.name": "Baluarte",
  "tech.bulwark.desc": "Preparación para jefes: +35% de defensa y +40 de defensa fija.",
  "tech.surge.name": "Impulso de Producción",
  "tech.surge.desc": "+150% de producción durante 25 segundos. Repetible.",
  "artifact.double-harvest.name": "Hoz Gemela",
  "artifact.double-harvest.desc": "Duplica el rendimiento de recolección y +50% de daño de recolección.",
  "artifact.aegis.name": "Núcleo Égida",
  "artifact.aegis.desc": "Duplica la defensa del asentamiento.",
  "artifact.resource-magnet.name": "Piedra Imán",
  "artifact.resource-magnet.desc": "+60% de producción y +50% de recolección automática.",
  "artifact.chronosphere.name": "Cronoesfera",
  "artifact.chronosphere.desc": "+50% más de tiempo entre oleadas.",
  "artifact.philosophers-stone.name": "Piedra Filosofal",
  "artifact.philosophers-stone.desc": "Duplica el conocimiento y +30% de producción.",
  "building.house.name": "Casa",
  "building.house.desc": "Alberga colonos, aumentando la población y la mano de obra.",
  "building.lumberCamp.name": "Campamento Maderero",
  "building.lumberCamp.desc": "Tala madera automáticamente.",
  "building.quarry.name": "Cantera",
  "building.quarry.desc": "Extrae piedra automáticamente.",
  "building.mine.name": "Mina",
  "building.mine.desc": "Extrae mineral y fortalece toda la economía.",
  "building.barracks.name": "Cuartel",
  "building.barracks.desc": "Entrena defensores, aumentando la defensa del asentamiento.",
  "building.school.name": "Escuela",
  "building.school.desc": "Produce conocimiento y mejora la tecnología y la defensa.",
  "resource.wood.name": "Madera",
  "resource.stone.name": "Piedra",
  "resource.ore.name": "Mineral",
  "resource.knowledge.name": "Conocimiento",
  // Calamities (v0.10)
  "calamity.quake.name": "Terremoto",
  "calamity.quake.desc": "La tierra se abrió bajo el asentamiento. Los almacenes cayeron en las grietas.",
  "calamity.flood.name": "Gran Inundación",
  "calamity.flood.desc": "El río creció por la noche y se llevó lo que quiso.",
  "calamity.drought.name": "Sequía",
  "calamity.drought.desc": "Los pozos se agotan. Todo va más lento bajo el cielo blanco y plano.",
  "calamity.plague.name": "Peste",
  "calamity.plague.desc": "Llegó con una caravana y se quedó. Los sanadores hicieron lo que pudieron.",
  "calamity.great-fire.name": "Gran Incendio",
  "calamity.great-fire.desc": "Empezó en un granero. Al amanecer, un barrio entero era ceniza.",
  "calamity.collapse.name": "El Derrumbe",
  "calamity.collapse.desc": "La gran obra fracasó. Los ingenieros se culpan entre sí.",
  "calamity.market-crash.name": "Crac del Mercado",
  "calamity.market-crash.desc": "El mercado de botines quebró de la noche a la mañana. Fortunas de papel, cenizas de papel.",
  "calamity.embargo.name": "Embargo Comercial",
  "calamity.embargo.desc": "Las rutas están cerradas. Las caravanas esperan en fronteras que antes eran líneas en un mapa.",
  "calamity.unrest.name": "Disturbios",
  "calamity.unrest.desc": "La multitud de la plaza dejó de corear y empezó a llevarse cosas.",
  "calamity.exodus.name": "El Éxodo",
  "calamity.exodus.desc": "Una caravana partió antes del alba. Se llevaron sus tiendas, sus rebaños y sus dudas.",
};
